import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import _ from 'lodash';
import { Subscription } from 'rxjs';

import { AppRoutingService } from 'src/app/core/routing/app-routing.service';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
})
export class ErrorPageComponent implements OnInit, OnDestroy {
  private routerQueryParams$!: Subscription;

  errorLabel: any;
  title: any;
  statusCode: any;
  message: any;
  desc: any;
  goBackButtonText: any;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: AppRoutingService,
  ) { }

  ngOnInit() {
    this.routerQueryParams$ = this.getQueryParamsSubject();
  }

  ngOnDestroy(): void {
    this.routerQueryParams$?.unsubscribe();
  }

  /**
   * Đọc mã lỗi từ `?s=` và dựng các KHOÁ i18n cho khung nhìn.
   *
   * Phần này trước đây bị chú thích lại cùng với việc route `error` chưa từng
   * được khai — bật route mà để nguyên thì trang hiện ra trống trơn (mọi khoá
   * đều `undefined`). Nay `CanLazyloadModuleGuard` điều hướng thật vào đây
   * (`error?s=403`) nên trang phải nói được nó đang báo lỗi gì.
   *
   * Chỉ nhận 403 và 500 — hai mã mà `AppRoutingService` thực sự phát ra ngoài
   * 404; mọi giá trị khác (thiếu, rác, người dùng tự gõ) rơi về trang 404 thay
   * vì dựng một khoá i18n không tồn tại rồi phơi khoá thô ra màn hình.
   */
  private getQueryParamsSubject = () => {
    return this.route.queryParams.subscribe(params => {
      const statusCode = parseInt(params['s'], 10);

      if (_.includes([403, 500], statusCode)) {
        this.getTranslate(statusCode);
      } else {
        this.getTranslate('404Page');
      }
    });
  }

  /**
   * Dựng các khoá i18n theo mã trạng thái. Bảng chữ nằm ở khối `error` trong
   * `assets/branch/sinhvien-hutech/i18n/{vi,es}.json`.
   */
  private getTranslate = (statusCode: number | string) => {
    this.statusCode = `error.${statusCode}.status`;
    this.message = `error.${statusCode}.message`;
    this.desc = `error.${statusCode}.desc`;
    this.title = `error.${statusCode}.title`;
  }

  /**
  * Hàm để chuyển hướng đến trang chủ hoặc trang đăng nhập dựa vào tính hợp lệ của JWT
  */
  navigateToHome = () => {
    this.router.navigateToHomePage();
  }
}
